/**
 * Styled Components - Created by david on 12/02/18.
 */
import styled, { keyframes } from 'styled-components'
import Spin from 'antd/lib/spin'
import Checkbox from 'antd/lib/checkbox/Checkbox'
import { RED, WHITE } from '../../theme/colors'

interface StyleProps {
  withBorder?: boolean
  withMargin?: boolean
  selectProduct?: boolean
  fromTop?: boolean
  isSelected?: boolean
  fitContainer?: boolean
  designLabView?: boolean
  fromStore?: boolean
  order?: number
}

export const Container = styled.section`
  height: 100%;
  margin: ${({ withMargin }: StyleProps) => (withMargin ? '16px 12px' : '0')};
  margin-bottom: ${({ selectProduct }: StyleProps) => (selectProduct ? '16px' : '0')};
  width: ${({ fitContainer }: StyleProps) => (fitContainer ? '100%' : '220px')};
  ${({ fromTop, order }: StyleProps) => fromTop ? `
    width: 188px;
    margin: 0 9px;
    margin-bottom: 9px;
    order: ${order || 99};
  ` : ''}
  ${({ designLabView }: StyleProps) => designLabView ? `
    max-width: 200px;
  ` : ''}
  transition: all .35s;
  &:hover {
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.08);
  }
  @media (min-width: 320px) and (max-width: 480px) {
    margin: 0 auto;
    width: 100%;
    ${({ fromStore }: StyleProps) => fromStore ? `display: flex` : ''};
  }
  .image-section {
    position: relative;
    overflow: hidden;
  }
  .thumbnail-design {
    border: unset;
    background: var(--lightened-cool);
  }
  .page-thumbnail {
    width: 100%;
    height: 376px;
    padding-block: var(--spacing-16) var(--spacing-24);
  }
  .image-thumbnail {
    width: 100%;
    height: 100%;
  }
  .add-to-cart-wrapper {
    display: none;
  }
  @media (min-width: 768px) {
    &:hover .add-to-cart-wrapper {
      display: block;
    }
  }
  @media (max-width: 767px) {
    display: flex;
    align-items: stretch;
    width: 100%;
    .image-section {
      width: 100%;
      max-width: 184px;
      flex-shrink: 0;
    }
    .thumbnail-design {
      width: 100%;
      padding: 0;
    }
    .page-thumbnail {
      height: 248px;
      padding: var(--spacing-24) var(--spacing-8);
    }
  }
`

export const NotificationsBadge = styled.div`
  position: relative;
  z-index: 3;
  float: right;
  margin-top: -17px;
  top: 17px;
  background: ${RED};
  width: 19px;
  text-align: center;
  color: white;
  border-radius: 50%;
  font-size: 11px;
  height: 19px;
  align-items: center;
  display: flex;
  justify-content: center;
`

export const Text = styled.div`
  color: ${WHITE};
`
export const BuyNow = styled.div`
  font-size: 10px;
  border: 1px solid #51ce04;
  color: #51ce04;
  padding: 2px 4px;
  margin-left: 2px;
  letter-spacing: 1px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 4px;
  border-radius: 4px;
  &:hover {
    background: #51ce04;
    color: white;
  }
`

export const BuyLoader = styled(Spin)`
  align-items: center;
  justify-content: center;
  display: flex;
  margin-left: 16px;
  margin-top: 4px;
`

export const ImageContainer = styled.div`
  user-select: none;
  cursor: pointer;
  background-color: #f1f4f5;
  height: 214.13px;
  width: ${({ fitContainer }: StyleProps) => (fitContainer ? '100%' : '220px')};
  padding: 10px;
  text-align: center;
`

export const Image = styled.img`
  user-select: none;
  height: 200.29px;
  width: 180.44px;
`

export const ImageTop = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  justify-content: space-between;
`
export const TopContainer = styled.div`
  height: 35.04px;
  width: 36px;
  background-color: #e61737;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const TopText = styled.div`
  color: #ffffff;
  font-size: 8px;
  font-weight: 500;
  line-height: 11px;
  text-align: center;
  text-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.24);
`

export const QuickView = styled.img``

export const YouthLabel = styled.div`
  color: var(--neutral-secondary);
  font: 400 12px/20px var(--font-inter);
  position: absolute;
  right: var(--spacing-8);
  top: var(--spacing-8);
  @media (max-width: 767px) {
    top: unset;
    right: unset;
    bottom: var(--spacing-8);
    left: var(--spacing-8);
  }
`

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

export const Arrows = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  top: 165px;
  width: 200px;
  justify-content: space-between;
  animation: ${fadeIn} 0.6s linear;
`

export const Arrow = styled.img`
  user-select: none;
`

export const CheckboxCompare = styled(Checkbox)`
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  width: 80px;
  height: 24px;
  padding: var(--spacing-4) var(--spacing-8);
  margin: 0;
  cursor: pointer;
  border-radius: 0;
  border: var(--border-regular) solid var(--neutral-border-med);
  background: var(--neutral-lightest-block);
  color: var(--neutral-body);
  font: 500 10px/14px var(--font-barlow);
  letter-spacing: 0.2px;
  text-transform: uppercase;
  white-space: nowrap;
  position: absolute;
  z-index: 10;
  left: var(--spacing-8);
  top: var(--spacing-8);

  .ant-checkbox {
    top: 0;
  }

  .ant-checkbox + span {
    padding-left: var(--spacing-4);
    padding-right: 0;
  }

  .ant-checkbox-inner {
    width: 12px;
    height: 12px;
    border-radius: 0;
    border: 1px solid var(--neutral-secondary);
    background: var(--neutral-white);
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    border-color: var(--neutral-white);
    ::after {
      border-color: var(--neutral-darkest);
      margin-left: -2px;
      width: 4px;
      height: 7px;
    }
  }

  .ant-checkbox-checked:after,
  .ant-checkbox-input:focus + .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  &:hover .ant-checkbox-inner {
    border-color: var(--neutral-secondary);
  }

  &:has(.ant-checkbox-checked) {
    background: var(--neutral-darkest);
    /* border-color: var(--neutral-darkest); */
    color: var(--neutral-white);
  }

  @media (max-width: 767px) {
    right: var(--spacing-4);
    top: var(--spacing-4);
    left: unset;
  }
`

export const AddToCartAnimated = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  animation: fade-in-cart 0.25s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  & > div > div {
    border-radius: 0;
    padding: var(--spacing-12);
    color: var(--neutral-white);
    font: 600 12px/18px var(--font-barlow);
    letter-spacing: 1px;
  }
  @keyframes fade-in-cart {
    0% {
      transform: translateY(14px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ProductThumbnailV2/styledComponents.tsx